import * as types from './action-types'

export const fetchNoShowReasons = () => ({
  type: types.NO_SHOW_REASONS_FETCH_BEGIN,
})
